<template>
  <div class="border-b border-cockpit-line py-3 mb-3 text-cockpit-muted text-xs"><b class="text-cockpit-critical">* </b>Campo obrigatório.</div>
</template>
